import { useNavigate } from "react-router-dom";

import { DataTable } from "../../../components";
import convertDate from "../../../utils/convertDate";
import pages from "../../../constants/pages";

export default function Table({ workflows }) {
  const navigate = useNavigate();

  const options = {
    onRowClick: handleRowClick,
    sortOrder: {
      name: "created_at",
      direction: "desc",
    },
  };

  function handleRowClick(_, rowMetaData) {
    navigate(
      pages.workflowDetailsPage.route + workflows[rowMetaData.dataIndex]._id
    );
  }

  return <DataTable columns={columns} options={options} data={workflows} />;
}

const columns = [
  {
    name: "workflow_name",
    label: "Workflow Name",
    options: {
      customBodyRender: (value) => {
        return value ? value : "Not Available";
      },
    },
  },
  {
    name: "description",
    label: "Workflow Description",
    options: {
      customBodyRender: (value) => {
        return value ? value : "Not Available";
      },
    },
  },

  {
    name: "execution_flow",
    label: "Execute When",
    options: {
      customBodyRender: (value) => {
        return value ? value : "Not Available";
      },
    },
  },
  {
    name: "created_at",
    label: "Created At",
    options: {
      customBodyRender: (value) => {
        return value ? convertDate(value) : "Not Available";
      },
    },
  },
];
